import { forwardRef } from "react";
import { HelperText } from "@hireart/component-library";
import { useField } from "formik";
import isEmpty from "lodash/isEmpty";
import PropTypes from "prop-types";
import { GooglePlacesAutocomplete } from "../GooglePlacesAutocomplete";

/**
 * FormGooglePlacesAutocomplete wires up GooglePlacesAutocomplete with Formik
 */
export const FormGooglePlacesAutocomplete = forwardRef(
  (
    {
      "aria-describedby": ariaDescribedBy = undefined,
      autocompleteClassName = "",
      className = "",
      id = undefined,
      isDisabled = false,
      isOptional = false,
      label = undefined,
      name,
      onChange = () => {},
      onSelect = () => {},
    },
    ref
  ) => {
    const [field, meta] = useField(name || id);
    const hasError = meta.touched && !isEmpty(meta.error);
    const autocompleteId = id || name;
    const helperTextIds = [
      hasError ? `${autocompleteId}-error` : undefined,
      ariaDescribedBy,
    ]
      .filter(Boolean)
      .join(" ");

    const handleChange = (e, value) => {
      field.onChange({ target: { value, name } });
      onChange(e, value);
    };

    const handleClear = () => {
      field.onChange({ target: { value: "", name } });
    };

    return (
      <div className={className}>
        <GooglePlacesAutocomplete
          ref={ref}
          aria-describedby={isEmpty(helperTextIds) ? undefined : helperTextIds}
          className={autocompleteClassName}
          hasError={hasError}
          id={id || name}
          isDisabled={isDisabled}
          isOptional={isOptional}
          label={label}
          onChange={handleChange}
          onSelect={onSelect}
          onClear={handleClear}
          value={field.value}
        />
        {hasError && <HelperText hasError>{meta.error}</HelperText>}
      </div>
    );
  }
);

FormGooglePlacesAutocomplete.propTypes = {
  "aria-describedby": PropTypes.string,
  autocompleteClassName: PropTypes.string,
  className: PropTypes.string,
  id: PropTypes.string,
  isDisabled: PropTypes.bool,
  isOptional: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  onSelect: PropTypes.func,
};
